"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PhotoCarouselSwipeableContainerMixin = void 0;
var _styledComponents = require("styled-components");
var _styledToken = _interopRequireDefault(require("styled-token"));
/** @class PhotoCarouselSwipeableContainerMixin */
/** @method */
var PhotoCarouselSwipeableContainerMixin = function PhotoCarouselSwipeableContainerMixin(props) {
  var shouldAnimateTranslations = props.shouldAnimateTranslations;
  return (0, _styledToken.default)({
    animationDuration: 'PhotoCarousel.animations.defaultDuration',
    animationFunction: 'PhotoCarousel.animations.defaultTimingFunction'
  }, function (_ref) {
    var animationDuration = _ref.animationDuration,
      animationFunction = _ref.animationFunction;
    return (0, _styledComponents.css)(["display:flex;flex:1;position:relative;z-index:0;height:100%;touch-action:pan-y;transition:transform ", "s ", ";@media (prefers-reduced-motion:reduce){&{transition:none;}}@media (hover:none){transform:translate3d(0,0,0);}"], shouldAnimateTranslations ? animationDuration : '0', animationFunction);
  });
};
exports.PhotoCarouselSwipeableContainerMixin = PhotoCarouselSwipeableContainerMixin;